import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ContactService } from '@profile/infra';
import { CreateContactMessageBody } from '@core-http';

export class ReportProfileCommandHandler {
  private readonly contactService: ContactService = inject(ContactService);

  report(reportedUserId: string, reportedDisplayName: string, message: string): Observable<void> {
    const requestBody: CreateContactMessageBody = {
      message: `ZGŁOSZENIE PROFILU\nZgłoszony: ${reportedDisplayName} (${reportedUserId})\n\n${message}`
    };

    return this.contactService.sendMessage(requestBody);
  }
}
